declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, string | number | boolean>) => void;
    };
  }
}

export const analytics = {
  track(event: string, data?: Record<string, string | number | boolean>) {
    window.umami?.track(event, data);
  },

  gameStarted(mode: 'local' | 'multiplayer', playerCount: number, teamCount: number) {
    this.track('game-started', { mode, playerCount, teamCount });
  },

  gameEnded(winnerTeam: string, turns: number, duration: number) {
    this.track('game-ended', { winnerTeam, turns, duration: Math.round(duration) });
  },

  roomCreated() {
    this.track('room-created');
  },

  roomJoined() {
    this.track('room-joined');
  },

  weaponFired(weaponId: string) {
    this.track('weapon-fired', { weapon: weaponId });
  },

  wormKilled(cause: string) {
    this.track('worm-killed', { cause });
  },
};
